import { render, staticRenderFns } from "./SGKExitMyApprovalsView.vue?vue&type=template&id=3c46d466&"
import script from "./SGKExitMyApprovalsView.vue?vue&type=script&lang=js&"
export * from "./SGKExitMyApprovalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports